import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Guest from "../../../assets/img/src/no-profile.png";
import { useSelector } from "react-redux";
import { getUserId } from "../../../reducks/users/selectors";
import { createStyles, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() =>
  createStyles({
    avatarBox: {},
    avatar: { width: 35, height: 35 },
  })
);

const Chat = (props) => {
  const classes = useStyles();
  const selector = useSelector((state) => state);
  const currentUserId = getUserId(selector);
  // console.log("currentUserIdは" + currentUserId);
  const avatar = props.avatar;
  // const sendId = props.sendId;
  // const sendName = props.sendName;
  // const message = props.message;
  // console.log("avatarは" + avatar, "sendIdは" + sendId, "sendNameは" + sendName, "messageは" + message);
  const ListsPosition = currentUserId !== props.sendId ? "chat__row" : "chat__reverse";

  return (
    <ListItem className={ListsPosition}>
      <ListItemAvatar className={classes.avatarBox}>
        {typeof avatar !== "undefined" ? (
          <Avatar className={classes.avatar} alt="icon" src={avatar} />
        ) : (
          <Avatar alt="icon" src={Guest} />
        )}
      </ListItemAvatar>
      <div>
        <div className="chat-user-name yu-gothic right">{props.sendName}</div>
        <div className="chat__bubble">{props.message}</div>
      </div>
    </ListItem>
  );
};
export default Chat;
